import type { ActiveFrenchActivitySpecificFieldKeys } from '@insify/shared-company-policy-model';

// The questions will be rendered in the order they are defined in these arrays

// The questions that we show on the additional-questions page, right after the activity selection
export const additionalQuestionKeys: ActiveFrenchActivitySpecificFieldKeys = [
  'kidsUnderThree',
  'kidsNumber',
  'decennaleRequired',
  'regulatedProfession',
  'stationaryStore',
  'importOutsideEu',
  'ownBrand',
  'tradeElectronics',
  'workOnCustomerSite',
  'cosmeticInvasiveProcedures',
];

export const discountQuestionKeys: ActiveFrenchActivitySpecificFieldKeys = [
  'capDegree',
  'workingOnlyAtInstitutions',
  'minThreeYearsExperience',
  'relevantDegree',
];
